import { useTranslation } from "react-i18next";

const Footer = ({ homeAnchors = false }: { homeAnchors?: boolean }) => {
  const { t } = useTranslation();
  //   <svg
  //     width="19"
  //     height="19"
  //     viewBox="0 0 19 19"
  //     fill="none"
  //     xmlns="http://www.w3.org/2000/svg"
  //   >
  //     <path
  //       d="M13.6278 10.4651L14.1445 7.09811H10.9138V4.91315C10.9138 3.99201 11.3651 3.09411 12.812 3.09411H14.2808V0.227471C14.2808 0.227471 12.9479 0 11.6736 0C9.01299 0 7.27389 1.61265 7.27389 4.53198V7.09811H4.31641V10.4651H7.27389V18.6047H10.9138V10.4651H13.6278Z"
  //       fill="white"
  //       className="group-hover:fill-[#192A42]"
  //     />
  //   </svg>,
  //   <svg
  //     width="19"
  //     height="19"
  //     viewBox="0 0 19 19"
  //     fill="none"
  //     xmlns="http://www.w3.org/2000/svg"
  //   >
  //     <path
  //       d="M14.1413 1.74414H16.7067L11.1035 8.14676L17.695 16.8604H12.5352L8.49083 11.577L3.86873 16.8604H1.29969L7.2917 10.0109L0.972656 1.74414H6.26335L9.91524 6.57336L14.1413 1.74414ZM13.2401 15.327H14.6609L5.48937 3.19763H3.96321L13.2401 15.327Z"
  //       fill="white"
  //       className="group-hover:fill-[#192A42]"
  //     />
  //   </svg>,
  //   <svg
  //     width="19"
  //     height="19"
  //     viewBox="0 0 19 19"
  //     fill="none"
  //     xmlns="http://www.w3.org/2000/svg"
  //   >
  //     <path
  //       d="M9.30996 5.12239C6.99891 5.12239 5.13481 6.98649 5.13481 9.29753C5.13481 11.6086 6.99891 13.4727 9.30996 13.4727C11.621 13.4727 13.4851 11.6086 13.4851 9.29753C13.4851 6.98649 11.621 5.12239 9.30996 5.12239ZM9.30996 12.0119C7.8165 12.0119 6.59557 10.7946 6.59557 9.29753C6.59557 7.80044 7.81286 6.58314 9.30996 6.58314C10.807 6.58314 12.0243 7.80044 12.0243 9.29753C12.0243 10.7946 10.8034 12.0119 9.30996 12.0119ZM14.6297 4.9516C14.6297 5.49303 14.1937 5.92544 13.6559 5.92544C13.1145 5.92544 12.682 5.48939 12.682 4.9516C12.682 4.41381 13.1181 3.97777 13.6559 3.97777C14.1937 3.97777 14.6297 4.41381 14.6297 4.9516ZM17.395 5.93998C17.3332 4.63547 17.0352 3.47995 16.0796 2.52791C15.1275 1.57588 13.972 1.27791 12.6675 1.2125C11.323 1.1362 7.29324 1.1362 5.94876 1.2125C4.64789 1.27428 3.49237 1.57224 2.5367 2.52428C1.58103 3.47631 1.2867 4.63184 1.22129 5.93634C1.14499 7.28082 1.14499 11.3106 1.22129 12.6551C1.28307 13.9596 1.58103 15.1151 2.5367 16.0672C3.49237 17.0192 4.64426 17.3172 5.94876 17.3826C7.29324 17.4589 11.323 17.4589 12.6675 17.3826C13.972 17.3208 15.1275 17.0228 16.0796 16.0672C17.0316 15.1151 17.3296 13.9596 17.395 12.6551C17.4713 11.3106 17.4713 7.28445 17.395 5.93998ZM15.6581 14.0977C15.3746 14.8099 14.8259 15.3586 14.1101 15.6456C13.0382 16.0708 10.4945 15.9727 9.30996 15.9727C8.12536 15.9727 5.57812 16.0672 4.50981 15.6456C3.7976 15.3622 3.24891 14.8135 2.96185 14.0977C2.5367 13.0257 2.63481 10.4821 2.63481 9.29753C2.63481 8.11294 2.54033 5.5657 2.96185 4.49739C3.24528 3.78518 3.79397 3.23649 4.50981 2.94942C5.58176 2.52428 8.12536 2.62239 9.30996 2.62239C10.4945 2.62239 13.0418 2.52791 14.1101 2.94942C14.8223 3.23285 15.371 3.78155 15.6581 4.49739C16.0832 5.56934 15.9851 8.11294 15.9851 9.29753C15.9851 10.4821 16.0832 13.0294 15.6581 14.0977Z"
  //       fill="white"
  //       className="group-hover:fill-[#192A42]"
  //     />
  //   </svg>,
  //   <svg
  //     width="19"
  //     height="19"
  //     viewBox="0 0 19 19"
  //     fill="none"
  //     xmlns="http://www.w3.org/2000/svg"
  //   >
  //     <path
  //       d="M4.48813 2.2487C4.48813 3.49063 3.48343 4.49741 2.24407 4.49741C1.0047 4.49741 0 3.49063 0 2.2487C0 1.00678 1.0047 0 2.24407 0C3.48343 0 4.48813 1.00678 4.48813 2.2487Z"
  //       fill="white"
  //       className="group-hover:fill-[#192A42]"
  //     />
  //     <path
  //       d="M0.306881 6.1503H4.14289V18.6047H0.306881V6.1503Z"
  //       fill="white"
  //       className="group-hover:fill-[#192A42]"
  //     />
  //     <path
  //       d="M10.3189 6.1503H6.48286V18.6047H10.3189C10.3189 18.6047 10.3189 14.6838 10.3189 12.2324C10.3189 10.761 10.7878 9.2831 12.6588 9.2831C14.7734 9.2831 14.7606 11.2087 14.7508 12.7005C14.7379 14.6504 14.7686 16.6403 14.7686 18.6047H18.6047V12.0315C18.5722 7.83439 17.5514 5.90044 14.1932 5.90044C12.1989 5.90044 10.9627 6.87051 10.3189 7.74816V6.1503Z"
  //       fill="white"
  //       className="group-hover:fill-[#192A42]"
  //     />
  //   </svg>,
  // ];

  const quickLinks = [
    { label: t("landing.footer.quickLinks.home"), href: homeAnchors ? "/#hero" : "#hero" },
    { label: t("landing.footer.quickLinks.about"), href: homeAnchors ? "/#about" : "#about" },
    { label: t("landing.footer.quickLinks.features"), href: homeAnchors ? "/#features" : "#features" },
  ];

  const productLinks = [
    { label: t("landing.footer.product.foodCosting"), href: "/product/food-costing/" },
    { label: t("landing.footer.product.invoiceProcessing"), href: "/product/invoice-processing/" },
    { label: t("landing.footer.product.priceAlerts"), href: "/product/price-alerts/" },
    { label: t("landing.footer.product.inventory"), href: "/product/inventory-management/" },
    { label: t("landing.footer.product.wasteTracking"), href: "/product/waste-tracking/" },
    { label: t("landing.footer.product.aiSoftware"), href: "/product/ai-restaurant-software/" },
    { label: t("landing.footer.product.productOverviewNl"), href: "/producten/" },
  ];

  const legalLinks = [
    { label: t("landing.footer.legal.privacy"), href: "/culinary-cloud-privacy-policy" },
    { label: t("landing.footer.legal.terms"), href: "/terms-and-conditions" },
    { label: t("landing.footer.legal.cookies"), href: "/cookies-policy" },
  ];

  const guideLinks = [
    { label: t("landing.footer.guides.foodcostBerekenenNl"), href: "/guides/foodcost-berekenen/" },
    { label: t("landing.footer.guides.foodCostSoftwareNl"), href: "/guides/food-cost-software-nl/" },
    { label: t("landing.footer.guides.foodCostSoftwareEn"), href: "/guides/food-cost-software-en/" },
    { label: t("landing.footer.guides.toolsComparedNl"), href: "/guides/beste-food-cost-software-nederland-nl/" },
    { label: t("landing.footer.guides.toolsComparedEn"), href: "/guides/best-food-cost-software-netherlands-en/" },
    { label: t("landing.footer.guides.menuPlanningNl"), href: "/guides/menuplanning-software-restaurantketens/" },
    { label: t("landing.footer.guides.horekoNl"), href: "/guides/horeko-kosten-alternatief/" },
  ];

  return (
    <div id="contact" className="w-full bg-landingPageBG pt-8 md:pt-12 lg:pt-[100px]">
      <div className="max-w-[1200px] mx-auto px-4">
        {/* Main Footer Grid */}
        <div className="flex items-start justify-between flex-wrap sm:flex-row flex-col gap-6 sm:gap-12 pb-12">
          {/* Brand Section */}
          <div>
            <img src="/assets/logo.svg" alt="logo" width={226} height={48} />
            <p className="mt-4 text-white/70 max-w-[262px] text-[14px] font-normal leading-[22px]">
              {t("landing.footer.tagline")}
            </p>
            <div className="mt-3">
              <h4 className="text-white text-[16px] font-medium mb-1">{t("landing.footer.contactUs")}</h4>
              <span
                className="text-white/70 text-[15px] hover:text-white font-normal transition"
              >
                contact@culinarycloud.nl
              </span>
            </div>
            {/* Social Media Icons */}
            {/* <div className="flex gap-3">
              {socialIcons.map((icon, index) => (
                <a
                  key={index}
                  href="#"
                  className="w-10 h-10 bg-transparent hover:bg-white rounded-full flex items-center justify-center transition group border border-white/30"
                >
                  {icon}
                </a>
              ))}
            </div> */}
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-[20px] leading-7 font-medium mb-5">
              {t("landing.footer.quickLinks.title")}
            </h4>
            <ul className="space-y-4">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/75 text-[16px] leading-[22px] tracking-[0.128px] hover:text-white transition"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white text-[20px] leading-7 font-medium mb-5">
              {t("landing.footer.product.title")}
            </h4>
            <ul className="space-y-3">
              {productLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/75 text-[16px] leading-[22px] tracking-[0.128px] hover:text-white transition"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Guides */}
          <div>
            <h4 className="text-white text-[20px] leading-7 font-medium mb-5">
              {t("landing.footer.guides.title")}
            </h4>
            <ul className="space-y-3">
              {guideLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/75 text-[16px] leading-[22px] tracking-[0.128px] hover:text-white transition"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white text-[20px] leading-7 font-medium mb-5">
              {t("landing.footer.legal.title")}
            </h4>
            <ul className="space-y-3">
              {legalLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/75 text-[16px] leading-[22px] tracking-[0.128px] hover:text-white transition"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Subscribe */}
          {/* <div className="max-w-[304px] w-full">
            <h4 className="text-white text-[18px] leading-[25px] font-semibold mb-5">
              Subscribe
            </h4>
            <div className="h-[50px] flex items-center justify-between p-[5px] bg-white/10 rounded-xl overflow-hidden border border-white/10">
              <input
                type="email"
                placeholder="Email Address"
                className="flex-1 h-full px-4 py-3 bg-transparent text-white text-[16px] placeholder-[#EAEAEA] leading-[26px] outline-none"
              />
              <button className="w-10 h-10 rounded-lg bg-white text-primary hover:bg-gray-200 transition flex items-center justify-center">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 15L15 5M15 5H8.33333M15 5V11.6667"
                    stroke="#192A42"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div> */}
        </div>

        <div className="border-t border-white/20 py-[30px]">
          <h3 className="text-white text-[16px] leading-6 font-normal tracking-[0.128px]">
            {t("landing.footer.copyright")}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Footer;
